// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const {
  mapStateToProps,
  mapDispatchToProps
} = require('client-v2/common/containers/auth-modal/actions-component')
// Sibling imports
const TopCallToActionExplainerButtons = require('./explainer-buttons-dumb')

function mergeProps(stateProps, dispatchProps) {
  const [onPrimaryClick, onSecondaryClick] = stateProps.isSULandingPage
  ? [dispatchProps.onSULoginClick, null]
  : [dispatchProps.onSignupClick, dispatchProps.onLoginClick]
  return {
    onPrimaryClick,
    onSecondaryClick
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(
  TopCallToActionExplainerButtons
)
